import React from 'react';
import Typed from 'react-typed';
import { useEffect } from 'react';

// import { Link } from 'react-router-dom';

function Azienda(lang) {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  /* 
  const timeline = [
    {
      year: '2017',
      description:
        'Modello Matematico di Inverter e Motore elettrico. Simulazione del Sistema Ibrido',
      logo: 'https://upload.wikimedia.org/wikipedia/it/thumb/5/59/Logo_della_Scuderia_Ferrari_%28vecchio%29.svg/1200px-Logo_della_Scuderia_Ferrari_%28vecchio%29.svg.png',
      nomeCliente: 'Ferrari',
      subtitle: 'Veicolo ibrido ad alte prestazioni',
    },
    {
      year: '2018',
      description: (
        <p>
          Progetto realizzato in partnership con 4e Consulting
          <br />
          Specifiche dei componenti
          <br />
          Supporto nella relazione con i fornitori
          <br />
          Modellazione e simulazione del sistema
          <br />
          Sviluppo della strategia ibrida dell'intero software e implementazione
          dell'unità di controllo del veicolo
        </p>
      ),
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Logo_Carraro.png',
      nomeCliente: 'CARRARO - 4e Consulting',
      subtitle: `Primo trattore ibrido al mondo presentato all'EIMA 2018`,
    },
    {
      year: '2019',
      description: (
        <p>
          Progetto realizzato in partnership con 4e Consulting
          <br />
          Specifiche dei componenti
          <br />
          Supporto nella relazione con i fornitori
          <br />
          Modellazione e simulazione del sistema
          <br />
          Sviluppo della strategia ibrida dell'intero software e implementazione
          dell'unità di controllo del veicolo
        </p>
      ),
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Manitou_Group_Logo.svg/1280px-Manitou_Group_Logo.svg.png',
      nomeCliente: 'MANITOU - 4e Consulting',
      subtitle: 'Sviluppo di un telehandler ibrido presentato a BAUMA 2019',
    },
    {
      year: '2020',
      description: (
        <p>
          Specifiche dei componenti
          <br />
          Realizzazione sistema di batterie e BMS Modellazione e simulazione del
          sistema
          <br />
          Sviluppo della strategia ibrida e dell'implementazione dell'unità di
          controllo del veicolo.
        </p>
      ),
      logo: 'https://www.efestoenergy.com/wp-content/uploads/2019/10/EFESTOlogo.jpg',
      nomeCliente: 'Efesto',
      subtitle: 'Moto ibrida ad alte prestazioni',
    },
    {
      year: '2020',
      description: (
        <p>
          Sviluppo di un Piantapali Ibrido Sviluppo dell’interna strategia
          ibrida software e implementazione della VCU proprietaria
        </p>
      ),
      logo: 'https://www.scaipspa.com/wp-content/uploads/2018/08/LOGO_SCAIP_HR.png',
      nomeCliente: 'Scaip',
      subtitle: 'Sviluppo di un Piantapali Ibrido',
    },
    {
      year: '2021',
      description: `Controllo Platform e sistema di immagazzinamento di energia
        per l’innovativo Idrogetto elettrico Deepspeed`,
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence',
      subtitle: '',
    },
    {
      year: '2022',
      description: ``,
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence Group',
      subtitle: 'Ingresso nella corporate Sealence Group',
    },
    {
      year: '2022',
      description: (
        <p>
          Batteria SAFEFLI
          <br />
          Sistema di controllo SMARTBOX
          <br />
          Generatore REX180
          <br />
          <br />
          <span className="font-bold">Allestimento imbarcazioni Prototipo</span>
        </p>
      ),
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence Group',
      subtitle: 'Realizzazione prodotti per ambito nautico',
    },
    {
      year: '2022',
      description: 'Passaggio da Start-up a PMI Innovativa',
      logo: '',
      nomeCliente: 'PMI Innovativa',
      subtitle: '',
    },
    {
      year: '2023',
      description:
        'Avviato il processo di omologazione presso enti certificatori RINA  e DNV',
      logo: '',
      nomeCliente: 'Certificazione e omologazione Prodotti',
      subtitle: '',
    },
  ];
  */

  const timeline = [
    {
      year: '2017 - 2018',
      description: `Nel 2017 abbiamo lavorato nell'ambito dei veicoli ibridi ad alte prestazioni, creando modelli elettrici, termici e meccanici di motori elettrici e inverter. Questo lavoro è stato ulteriormente potenziato nel 2018 con la presentazione del primissimo trattore ibrido a EIMA 2018. Abbiamo fornito le specifiche dei componenti, supportato i fornitori nelle loro relazioni, creato modelli e simulazioni di sistema e sviluppato strategie ibride software e implementazioni di unità di controllo del veicolo per questi veicoli.`,
      // logo: 'https://upload.wikimedia.org/wikipedia/it/thumb/5/59/Logo_della_Scuderia_Ferrari_%28vecchio%29.svg/1200px-Logo_della_Scuderia_Ferrari_%28vecchio%29.svg.png',
      // nomeCliente: 'Ferrari',
      // subtitle: 'Veicolo ibrido ad alte prestazioni',
    },
    {
      year: '2019 - 2020',
      description: (
        <p>
          Nella seconda parte del 2019, abbiamo ampliato ulteriormente i nostri
          orizzonti con lo sviluppo di un telehandler ibrido presentato al BAUMA
          2019. Anche in questo caso, abbiamo fornito le specifiche dei
          componenti, supportato i fornitori nelle loro relazioni, creato
          modelli e simulazioni di sistema e sviluppato strategie ibride
          software e implementazioni dell'unità di controllo del veicolo.
          Infine, il nostro lavoro si è focalizzato sullo sviluppo di una moto
          ibrida ad alte prestazioni, per la quale abbiamo fornito le specifiche
          della batteria e del sistema di gestione della batteria, i modelli e
          le simulazioni del sistema e abbiamo sviluppato strategie ibride
          software e implementazioni dell'unità di controllo del veicolo.
          <br />
          <br />
          Nel complesso, il nostro lavoro nel campo dei veicoli ibridi è stato
          innovativo e siamo orgogliosi di poter dire che siamo stati
          all'avanguardia in questa tecnologia, creando sistemi affidabili ed
          efficienti per alcuni dei veicoli più notevoli al mondo.
        </p>
      ),
      // logo: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Logo_Carraro.png',
      // nomeCliente: 'CARRARO - 4e Consulting',
      // subtitle: `Primo trattore ibrido al mondo presentato all'EIMA 2018`,
    },
    {
      year: '2021',
      description: (
        <p>
          Il 2021 è stato un anno di grandi cambiamenti per eDriveLAB, con la
          nuova collaborazione con Sealence ha permesso di cambiare il modello
          di business, da system integrator ad azienda di prodotto.
          <br />
          <br />
          Abbiamo sviluppato una serie di prodotti dedicati al mondo della
          nautica in collaborazione con SEALENCE Spa, tra cui una batteria al
          litio marinizzata, un range extender e tutta la logica di controllo
          dei sistemi dell' Innovativo Jet Deepspeed.
        </p>
      ),
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      // nomeCliente: 'MANITOU - 4e Consulting',
      // subtitle: 'Sviluppo di un telehandler ibrido presentato a BAUMA 2019',
    },
    {
      year: '2022',
      description: (
        <p>
          Nel 2022 abbiamo svolto importanti test su campo per verificare
          l'efficacia dei nostri prodotti e la loro affidabilità, unendo tutto
          il know-how acquisito negli anni precedenti. Nel corso dello stesso
          anno abbiamo raggiunto il traguardo di PMI Innovativa.
        </p>
      ),
      // logo: 'https://www.efestoenergy.com/wp-content/uploads/2019/10/EFESTOlogo.jpg',
      // nomeCliente: 'Efesto',
      // subtitle: 'Moto ibrida ad alte prestazioni',
    },
    {
      year: '2023',
      description: (
        <p>
          Nel 2023, l'azienda inizierà il processo di certificazione presso enti
          come il RINA e il DNV, garantendo la sicurezza e la qualità dei suoi
          prodotti. eDriveLAB si impegna a fornire ai propri clienti prodotti e
          servizi di altissima qualità e a continuare il suo sforzo di
          innovazione e sviluppo.
        </p>
      ),
      // logo: 'https://www.scaipspa.com/wp-content/uploads/2018/08/LOGO_SCAIP_HR.png',
      // nomeCliente: 'Scaip',
      // subtitle: 'Sviluppo di un Piantapali Ibrido',
    },
  ];

  return (
    <>
      <section className="container px-10 pt-16 mx-auto">
        <div className="text-center">
          <p className="text-3xl font-bold md:text-4xl">
            <span className="text-5xl text-blue-600">
              <Typed
                strings={['Innovare', 'Crescere', 'Progettare', 'Sviluppare']}
                typeSpeed={75}
                startDelay={25}
                backDelay={1500}
                backSpeed={25}
                loop
              />
            </span>
            <br />è il motto ispiratore della nostra azienda
          </p>
          <p className="mt-4">
            Una visione di crescita globale attraverso l’evoluzione di
            tecnologie e prodotti nell’ambito della mobilità sostenibile.
          </p>
        </div>
      </section>
      <section className="container flex flex-col gap-8 mx-auto mt-8 mb-16 lg:flex-row lg:gap-0">
        <div className="flex-1 p-8 mx-8 border border-green-700 rounded-lg">
          <div className="text-center">
            <span className="text-2xl font-bold text-green-700">Mission</span>
            {/* <h3 className="text-2xl font-bold">
              Rendere possibile la mobilità sostenibile
            </h3> */}
            <p className="mt-4">
              eDriveLAB srl è una PMI Innovativa, spin-off dell’Università di
              Parma, che nasce nel 2017 dalla volontà dei soci di applicare le
              proprie competenze nell’ambito dell’elettronica di potenza. Fin
              dalla sua costituzione, ha basato la propria attività verso i
              servizi di consulenza ingegneristica legati a progettazione e
              sviluppo di veicoli elettrificati di stampo innovativo.
            </p>
          </div>
        </div>
        {/* <div className="flex-1 p-8 mx-8 border border-blue-700 rounded-lg">
          <div className="text-center">
            <span className="font-bold text-blue-700">Vision</span>
            <h3 className="text-2xl font-bold">
              Rendere possibile la mobilità sostenibile
            </h3>
            <p className="mt-4">
              La nostra vision è quella di avviare attività di ricerca sia con
              aziende private che con partner pubblici (nazionali, europei e
              mondiali), portando sul mercato le innovazioni sviluppate negli
              anni.
            </p>
          </div>
        </div> */}
        <div className="flex-1 p-8 mx-8 border border-red-700 rounded-lg">
          <div className="text-center">
            <span className="text-2xl font-bold text-red-700">Obiettivo</span>
            {/* <h3 className="text-2xl font-bold">
              Rendere possibile la mobilità sostenibile
            </h3> */}
            <p className="mt-4">
              eDriveLAB punta ad espandere la propria capacità produttiva
              attraverso l’immissione nel mercato dei propri prodotti, forte di
              una sempre crescente rete di clienti che entrano in contatto con
              la società e che dimostrano una forte richiesta di
              approvvigionamento di prodotti per veicoli elettrificati,
              necessari per seguire il forte trend di transizione verso
              tecnologie più sostenibili.
            </p>
          </div>
        </div>
      </section>
      <section className="mx-auto">
        <div className="flex flex-col items-center justify-start w-full px-8 py-10 bg-slate-100">
          <span className="mb-10 text-4xl font-bold text-center">Timeline</span>
          {timeline &&
            timeline.map((event, id) => (
              <div className="flex flex-col items-center">
                <div className="max-w-2xl p-10 mx-auto bg-white border-2 border-blue-500 rounded-lg">
                  <div className="flex flex-col items-center gap-8 md:flex-row">
                    <div className="">
                      <img src={event.logo} alt="" className="max-w-[100px]" />
                    </div>
                    <div>
                      <div className="flex items-center justify-start gap-2">
                        <span className="px-4 py-2 text-lg font-bold text-blue-700 rounded-lg bg-blue-500/25">
                          {event.year}
                        </span>
                        {/* <span className="text-xl font-bold text-blue-700">
                          –
                        </span> */}
                        <span className="py-2 text-xl font-bold text-blue-700">
                          {event.nomeCliente}
                        </span>
                      </div>
                      <p className="mt-4 font-bold">{event.subtitle}</p>
                      <p className="mt-4">{event.description}</p>
                    </div>
                  </div>
                </div>
                {console.log(id)}
                {console.log(timeline.length)}
                {id + 1 !== timeline.length ? (
                  <div className="w-0.5 h-20 bg-blue-500"></div>
                ) : (
                  ''
                )}
              </div>
            ))}
        </div>
      </section>
    </>
  );
}

export default Azienda;
